export default __webpack_public_path__ + "static/media/Mask_Group_50.1dc533e5.svg";